import { type ReactNode } from 'react';
import WebFooter from './_components/Footer';
import WebNavbar from './_components/Navbar';

const WebLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="!bg-white">
      <WebNavbar />
      <div className="min-h-screen">{children}</div>
      <WebFooter />
    </div>
  );
};

export default WebLayout;
